'use strict';

var repeaterItemsUtils = require('./repeaterItemsUtils');

module.exports = {
  items: {
    getAddedItems: repeaterItemsUtils.getAddedItems,
    getRemovedItems: repeaterItemsUtils.getRemovedItems,
    getTemplateCompsId: repeaterItemsUtils.getTemplateCompIds
  },
  structure: {
    getUniqueDisplayedId: repeaterItemsUtils.getUniqueDisplayedId,
    getOriginalId: repeaterItemsUtils.getOriginalId,
    getItemId: repeaterItemsUtils.getItemId,
    SPLITTED_DATA_TYPES: repeaterItemsUtils.SPLITTED_DATA_TYPES
  }
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/repeaterUtils/repeaterUtils.js